import styled from 'styled-components';

import Btn from '@/components/Button';
import { fonts, colors, metrics } from '@/theme';

export const Container = styled.div`
  width: 415px;
  margin: 0;
  padding: 0;
  @media (max-width: ${metrics.mobile}px) {
    width: 100%;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (max-width: ${metrics.mobile}px) {
    flex-direction: row;
    padding-bottom: 10px;
    border-bottom: 1px solid ${colors.black};
  }
`;

export const TextInput = styled.input`
  ${fonts.getRegularText()}
  border: none;
  border-bottom: solid 1px ${colors.black};
  width: 100%;
  margin-bottom: 10px;

  :focus {
    outline: none;
  }

  ::placeholder {
    color: ${colors.form.placeholder};
  }
  @media (max-width: ${metrics.mobile}px) {
    flex: 1 1 auto;
    margin-bottom: 0;
    border-bottom: none;
  }
`;

export const Title = styled.label`
  display: block;
  ${fonts.getSmallText(true)}
  margin-bottom: 15px;
`;

export const Button = styled(Btn)`
  @media (max-width: ${metrics.mobile}px) {
    display: none;  
  }
`;

export const MobileBtn = styled.button`
  display: none;
  @media (max-width: ${metrics.mobile}px) {
    display: inline-block;
    border: none;
    outline: none;
    background: none;
    padding: 0;
    cursor: pointer;
  }
`;
